// import ClazzStandardApi from '../api/src/course_standard/api/ClazzStandardApi'
import {message} from "ant-design-vue";

// const clazzStandardApi = new ClazzStandardApi()

const Service = function() {
  let queue = []
  let working = false

  const next = function() {
    let fun = queue.shift()
    if(typeof fun === 'function'){
      fun()
    }else{
      working = false
    }
  }

  this.init = function() {
      console.log('init')
  }

  const map = {
    "add": function (query) {
      console.log(query);
      clazzStandardApi.addKnowledge(
          query.courseStandardId,
          query.body
      ).then(res=>{
        console.log(res, '添加成功')
        next()
      }).catch(err=>{
        message.error('请求失败，刷新页面重新尝试')
      })
    },
    'put': function (query){
      clazzStandardApi.updateKnowledge(query.courseStandardId,query.knowledgeId,query.body).then(res=>{
        console.log(res)
        next()
      }).catch(err=>{
        message.error('请求失败，刷新页面重新尝试')
      })
    },
    'drag': function (query){
      clazzStandardApi.dragKnowledge(
          query.courseStandardId,
          query.currentKnowledgeId,
          query.targetKnowledgeId,
          query.whereInsert
      ).then(res=>{
        console.log(res,'移动位置成功')
        next()
      }).catch(err=>{
        message.error('请求失败，刷新页面重新尝试')
      })
    },
    'delete': function (query){
      clazzStandardApi.deleteKnowledge(query.courseStandardId,query.knowledgeId).then(res=>{
        console.log(res)
        next()
      }).catch(err=>{
        message.error('请求失败，刷新页面重新尝试')
      })
    }
  }

  this.push = function(data,type) {
    queue.push(function() {
      map[type](data)
    })
    if(!working){
      working = true
      next()
    }
  }

}

export default Service
